(() => {
  let writing = false;
  const parse = (el) => JSON.parse(el.textContent);
  const amount = (input) => Number(input.tagName === 'SELECT' ? input.selectedOptions[0]?.dataset.price : input.dataset.price) || 0;
  const money = (root, value) => new Intl.NumberFormat(root.dataset.locale || 'en', { style: 'currency', currency: root.dataset.currency || 'EUR' }).format(value / 100);
  const jsonRequest = async (url, options = {}) => {
    const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json', ...options.headers }, ...options });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error('cart_request_failed');
    return data;
  };
  const updateCount = (cart) => document.querySelectorAll('.bag-count').forEach(el => { el.textContent = cart.item_count; });
  async function add(root, items, button, status, bagLink, strings) {
    if (writing || !items.length) return false;
    writing = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = strings.adding;
    let before;
    try {
      before = await jsonRequest(root.dataset.root + 'cart.js');
      await jsonRequest(root.dataset.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
      const after = await jsonRequest(root.dataset.root + 'cart.js');
      const quantities = cart => cart.items.reduce((map, line) => { map[String(line.variant_id)] = (map[String(line.variant_id)] || 0) + line.quantity; return map; }, {});
      const oldQuantities = quantities(before), newQuantities = quantities(after);
      const requested = items.reduce((map, line) => { map[String(line.id)] = (map[String(line.id)] || 0) + line.quantity; return map; }, {});
      if (!Object.entries(requested).every(([id, quantity]) => (newQuantities[id] || 0) >= (oldQuantities[id] || 0) + quantity)) throw new Error('cart_addition_not_confirmed');
      updateCount(after);
      status.textContent = strings.added;
      bagLink.hidden = false;
      if (root.dataset.mode === 'cart') window.location.assign(root.dataset.cart);
      return true;
    } catch {
      status.textContent = strings.error;
      bagLink.hidden = false;
      status.focus();
      return false;
    } finally {
      writing = false;
      button.removeAttribute('aria-busy');
    }
  }
  function initSets(root) {
    if (root.dataset.initialised) return;
    root.dataset.initialised = 'true';
    const strings = parse(root.querySelector('[data-pairing-strings]'));
    const filters = root.querySelector('[data-set-filters]');
    filters.hidden = Number(filters.dataset.setFilterCount) <= 1;
    filters.addEventListener('click', event => {
      const button = event.target.closest('[data-filter]');
      if (!button) return;
      filters.querySelectorAll('button').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
      root.querySelectorAll('[data-set-card]').forEach(el => { el.hidden = button.dataset.filter !== 'all' && el.dataset.group !== button.dataset.filter; });
    });
    root.querySelectorAll('[data-set-form]').forEach(form => {
      const inputs = [...form.querySelectorAll('[data-set-variant]')];
      form.addEventListener('change', () => {
        inputs.forEach(input => { input.closest('.set-item').querySelector('[data-unit-price]').textContent = money(root, amount(input)); });
        form.querySelector('[data-set-total]').textContent = money(root, inputs.reduce((sum, input) => sum + amount(input), 0));
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = form.querySelector('[data-set-add]');
        if (!button || button.disabled) return;
        const items = inputs.map(input => ({ id: Number(input.value), quantity: 1 }));
        await add(root, items, button, form.querySelector('[data-set-status]'), form.querySelector('[data-bag-link]'), strings);
      });
    });
  }
  function initPairings(root) {
    if (root.dataset.initialised) return;
    root.dataset.initialised = 'true';
    const strings = parse(root.querySelector('[data-pairing-strings]'));
    const context = parse(root.querySelector('[data-pairing-context]'));
    const cards = [...root.querySelectorAll('[data-pairing-card]')];
    const giftChoice = root.querySelector('[data-gift-extras]');
    const cheapChoice = root.querySelector('[data-extra-cheap]');
    const rail = root.querySelector('[data-pairing-grid]');
    const cartMode = root.dataset.mode === 'cart';
    const updateRail = () => {
      root.querySelectorAll('[data-pairing-scroll]').forEach(button => {
        button.disabled = button.dataset.pairingScroll === '-1' ? rail.scrollLeft < 2 : rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      });
    };
    const updateRecommendations = () => {
      if (!root.isConnected) { document.removeEventListener('sinroom:recommendation-memory', updateRecommendations); return; }
      const candidates = cards.map(card => ({ id: card.dataset.id, role: card.dataset.role, rank: Number(card.dataset.rank), price: Number(card.dataset.price), containsOil: card.dataset.containsOil === 'true', includesRoles: (card.dataset.includesRoles || '').split(',').filter(Boolean), available: card.dataset.added !== 'true' }));
      const recentCategories = window.SinroomRecommendationMemory?.get() || [];
      const options = { gift: !!giftChoice?.checked, recentCategories, shippingGap: Number(document.querySelector('[data-shipping-progress]')?.dataset.gap) || 0, maxPrice: cheapChoice?.getAttribute('aria-pressed') === 'true' ? 1000 : null };
      const matches = cartMode ? window.SinroomPairingRules.recommendCart(context, candidates, Number(root.dataset.limit) || 12, options) : window.SinroomPairingRules.recommend(context, candidates, 3, options);
      const selected = new Set(matches.map(c => String(c.id)));
      cards.forEach(card => { card.hidden = !selected.has(card.dataset.id); });
      if (cartMode) matches.forEach(item => rail.append(cards.find(card => card.dataset.id === String(item.id))));
      root.hidden = !selected.size && !(giftChoice && candidates.some(c => ['cards','giftkit'].includes(c.role)));
      const count = root.querySelector('[data-recommendation-count]');
      if (count) count.textContent = matches.length ? strings.count.replace('{count}', matches.length).replace('{basis}', recentCategories.length ? strings.recent_basis : strings.bag_basis) : strings.empty;
      requestAnimationFrame(updateRail);
    };
    updateRecommendations();
    giftChoice?.addEventListener('change', () => { updateRecommendations(); rail.scrollLeft = 0; });
    cheapChoice?.addEventListener('click', () => { cheapChoice.setAttribute('aria-pressed', String(cheapChoice.getAttribute('aria-pressed') !== 'true')); updateRecommendations(); rail.scrollLeft = 0; });
    document.addEventListener('sinroom:recommendation-memory', updateRecommendations);
    root.querySelectorAll('[data-pairing-scroll]').forEach(button => button.addEventListener('click', () => rail.scrollBy({left: Number(button.dataset.pairingScroll) * rail.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'})));
    rail.addEventListener('scroll', updateRail, {passive:true});
    rail.addEventListener('keydown', event => { if (event.target !== rail || !['ArrowLeft','ArrowRight'].includes(event.key)) return; event.preventDefault(); rail.scrollBy({left:(event.key === 'ArrowLeft' ? -1 : 1) * rail.clientWidth * .85, behavior:'instant'}); });
    new ResizeObserver(updateRail).observe(rail);
    const profiles = context.map(window.SinroomPairingRules.profile);
    root.querySelector('[data-oil-warning]').hidden = !(profiles.includes('oil') && profiles.includes('condoms'));
    if (profiles.includes('oil') && profiles.includes('condoms')) root.hidden = false;
    const status = root.querySelector('[data-pairing-status]'), bagLink = root.querySelector('[data-bag-link]');
    const cartForm = document.querySelector('[data-main-cart-form]');
    const pendingQuantities = () => cartForm && [...cartForm.querySelectorAll('[name="updates[]"]')].some(input => input.value !== input.defaultValue);
    const baseForm = document.querySelector('[data-product-section] form[action*="/cart/add"]');
    const combine = root.querySelector('[data-combine]');
    let combinedUsed = false;
    function updateCombined() {
      if (!combine || !baseForm) return;
      const checked = cards.filter(card => !card.hidden && card.querySelector('[data-extra-choice]')?.checked);
      combine.hidden = !checked.length;
      const baseInput = baseForm.querySelector('[name="id"]');
      const basePrice = baseInput?.tagName === 'SELECT' ? baseInput.selectedOptions[0]?.dataset.cents : baseInput?.dataset.cents;
      const quantity = Math.max(1, Number(baseForm.querySelector('[name="quantity"]')?.value) || 1);
      const extraTotal = checked.reduce((sum, card) => {
        const input = card.querySelector('[name="id"]');
        return sum + (input.tagName === 'SELECT' ? amount(input) : Number(card.dataset.price));
      }, 0);
      combine.querySelector('[data-combined-price]').textContent = money(root, Number(basePrice || 0) * quantity + extraTotal);
      combine.querySelector('button').disabled = combinedUsed || !baseInput?.value || !!baseForm.querySelector('[data-product-submit]')?.disabled;
    }
    cards.forEach(card => {
      const form = card.querySelector('form');
      form.addEventListener('change', () => {
        const input = form.querySelector('[name="id"]');
        if (input.tagName === 'SELECT') { card.dataset.price = amount(input); card.querySelector('[data-extra-price]').textContent = money(root, amount(input)); }
        if (cartMode) { const active = document.activeElement; updateRecommendations(); if (active?.isConnected) active.focus({preventScroll:true}); }
        updateCombined();
      });
      card.querySelector('[data-extra-choice]')?.addEventListener('change', updateCombined);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (pendingQuantities()) { status.textContent = strings.updateBag; status.focus(); return; }
        const button = form.querySelector('button');
        if (button.disabled) return;
        const choice = card.querySelector('[data-extra-choice]');
        const success = await add(root, [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }], button, status, bagLink, strings);
        if (choice) { choice.checked = false; choice.disabled = true; }
        if (success) card.dataset.added = 'true';
        updateCombined();
      });
    });
    baseForm?.addEventListener('change', updateCombined);
    baseForm?.addEventListener('input', updateCombined);
    combine?.querySelector('button').addEventListener('click', async () => {
      const button = combine.querySelector('button');
      if (button.disabled || !baseForm) return;
      if (!baseForm.reportValidity()) return;
      const chosenCards = cards.filter(card => !card.hidden && card.querySelector('[data-extra-choice]')?.checked);
      if (!chosenCards.length) return;
      const items = [{ id: Number(baseForm.querySelector('[name="id"]').value), quantity: Math.max(1, Number(baseForm.querySelector('[name="quantity"]').value) || 1) }, ...chosenCards.map(card => ({ id: Number(card.querySelector('[name="id"]').value), quantity: 1 }))];
      combinedUsed = true;
      await add(root, items, button, status, bagLink, strings);
      updateCombined();
    });
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-pleasure-sets]').forEach(initSets);
    scope.querySelectorAll('[data-pairings]').forEach(initPairings);
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
